import React from 'react'

export default function NavBreak() {
  return (
    <div className='mt-[73px]'></div>
  )
}
